import React from 'react';

import Typography from '@material-ui/core/Typography';

import fieldStyles from '../../styles/fieldStyles';

export default function Footer() {
  const classes = fieldStyles();
  return (
    <footer className={classes.footer}>
      <Typography>2020 - Fundació BIT - Illes Balears Innovació Tecnològica</Typography>
    </footer>
  );
}
